import { ref, Ref } from 'vue'
import ITask from '@/interfaces/ITask'
import ICountTaskByProcess from '@/interfaces/ICountTaskByProcess'
import config from '@/config/config';
import ITaskHistory from '@/interfaces/ITaskHistory';

interface ApiResponse {
    statusCode: number;
    isSuccess: boolean;
    errorMessages: string[];
    result: ITask[] | ICountTaskByProcess[] | ITaskHistory[];
}

class ApiService {
    private tasks:Ref<Array<ITask>>
    private countTaskByProcess:Ref<Array<ICountTaskByProcess>>
    private loading: Ref<boolean>
    private baseUrl: string
    private amountOfTasks: Ref<number>
    private detailTask: Ref<Array<ITaskHistory>>

    constructor(){
        this.tasks = ref<Array<ITask>>([])
        this.countTaskByProcess = ref<Array<ICountTaskByProcess>>([])
        this.loading = ref(false)
        this.baseUrl = config.apiBaseUrl
        this.amountOfTasks = ref(0)
        this.detailTask = ref<Array<ITaskHistory>>([])
    }

    getTasks():Ref<Array<ITask>>{
        return this.tasks
    }

    getCountTaskByProcess():Ref<Array<ICountTaskByProcess>>{
        return this.countTaskByProcess
    }

    getLoadingState(): Ref<boolean> {
        return this.loading
    }

    getAmountOfTasks(): Ref<number> {
        return this.amountOfTasks
    }

    getDetailTask(): Ref<Array<ITaskHistory>> {
        return this.detailTask
    }

    async fetchDetailTaskOffline(baseRef: string): Promise<void> {
        const response = `[
      {
         "id":1298,
         "relativeURL":"/FamiliasDefinibles_Ficha.aspx?3d4i2SRukiGvIDqIu0sJyoE2XIZHDHqMWiDnh4B218Yn1qyLweqLCQ==",
         "absoluteURL":"http://sistemas-des-int.procomer.com/FamiliasDefinibles_Ficha.aspx?3d4i2SRukiGvIDqIu0sJyoE2XIZHDHqMWiDnh4B218Yn1qyLweqLCQ==",
         "values":[
            {
               "valueType":"GroupOfFields",
               "elements":[
                  {
                     "values":[
                        {
                           "valueType":"StringSingle",
                           "elements":null,
                           "internalName":"3_Etapa_FamSeg",
                           "value":"Revisión del Autorizador"
                        },
                        {
                           "valueType":"StringSingle",
                           "elements":null,
                           "internalName":"3_Asignado_FamSeg",
                           "value":"AP2"
                        },
                        {
                           "valueType":"Date",
                           "elements":null,
                           "internalName":"3_Fecha_FamSeg",
                           "value":"2024-11-27T00:00:00"
                        },
                        {
                           "valueType":"Date",
                           "elements":null,
                           "internalName":"3_Completado_FamSeg",
                           "value":"2024-11-27T00:00:00"
                        },
                        {
                           "valueType":"StringMultiline",
                           "elements":null,
                           "internalName":"3_Razon_Rechazo_Seguimiento",
                           "value":"Porque ..."
                        }
                     ],
                     "id":4393,
                     "relativeURL":null,
                     "absoluteURL":null
                  },
                  {
                     "values":[
                        {
                           "valueType":"StringSingle",
                           "elements":null,
                           "internalName":"3_Etapa_FamSeg",
                           "value":"Revisión del Autorizador"
                        },
                        {
                           "valueType":"StringSingle",
                           "elements":null,
                           "internalName":"3_Asignado_FamSeg",
                           "value":"Katherine Córdoba"
                        },
                        {
                           "valueType":"Date",
                           "elements":null,
                           "internalName":"3_Fecha_FamSeg",
                           "value":"2024-11-27T00:00:00"
                        },
                        {
                           "valueType":"Date",
                           "elements":null,
                           "internalName":"3_Completado_FamSeg",
                           "value":"2024-11-27T00:00:00"
                        },
                        {
                           "valueType":"StringMultiline",
                           "elements":null,
                           "internalName":"3_Razon_Rechazo_Seguimiento",
                           "value":"jb"
                        }
                     ],
                     "id":4394,
                     "relativeURL":null,
                     "absoluteURL":null
                  },
                  {
                     "values":[
                        {
                           "valueType":"StringSingle",
                           "elements":null,
                           "internalName":"3_Etapa_FamSeg",
                           "value":"Devolución de Trámite"
                        },
                        {
                           "valueType":"StringSingle",
                           "elements":null,
                           "internalName":"3_Asignado_FamSeg",
                           "value":"Katherine Córdoba"
                        },
                        {
                           "valueType":"Date",
                           "elements":null,
                           "internalName":"3_Fecha_FamSeg",
                           "value":"2024-11-27T00:00:00"
                        },
                        {
                           "valueType":"Date",
                           "elements":null,
                           "internalName":"3_Completado_FamSeg",
                           "value":"2024-11-27T00:00:00"
                        },
                        {
                           "valueType":"StringMultiline",
                           "elements":null,
                           "internalName":"3_Razon_Rechazo_Seguimiento",
                           "value":null
                        }
                     ],
                     "id":4395,
                     "relativeURL":null,
                     "absoluteURL":null
                  },
                  {
                     "values":[
                        {
                           "valueType":"StringSingle",
                           "elements":null,
                           "internalName":"3_Etapa_FamSeg",
                           "value":"Devolución de Trámite"
                        },
                        {
                           "valueType":"StringSingle",
                           "elements":null,
                           "internalName":"3_Asignado_FamSeg",
                           "value":"Lucrecia Céspedes"
                        },
                        {
                           "valueType":"Date",
                           "elements":null,
                           "internalName":"3_Fecha_FamSeg",
                           "value":"2024-11-27T00:00:00"
                        },
                        {
                           "valueType":"Date",
                           "elements":null,
                           "internalName":"3_Completado_FamSeg",
                           "value":"2024-11-27T00:00:00"
                        },
                        {
                           "valueType":"StringMultiline",
                           "elements":null,
                           "internalName":"3_Razon_Rechazo_Seguimiento",
                           "value":null
                        }
                     ],
                     "id":4396,
                     "relativeURL":null,
                     "absoluteURL":null
                  },
                  {
                     "values":[
                        {
                           "valueType":"StringSingle",
                           "elements":null,
                           "internalName":"3_Etapa_FamSeg",
                           "value":"Revisión del Autorizador"
                        },
                        {
                           "valueType":"StringSingle",
                           "elements":null,
                           "internalName":"3_Asignado_FamSeg",
                           "value":"AP2"
                        },
                        {
                           "valueType":"Date",
                           "elements":null,
                           "internalName":"3_Fecha_FamSeg",
                           "value":"2024-11-27T00:00:00"
                        },
                        {
                           "valueType":"Date",
                           "elements":null,
                           "internalName":"3_Completado_FamSeg",
                           "value":"2024-11-27T00:00:00"
                        },
                        {
                           "valueType":"StringMultiline",
                           "elements":null,
                           "internalName":"3_Razon_Rechazo_Seguimiento",
                           "value":null
                        }
                     ],
                     "id":4397,
                     "relativeURL":null,
                     "absoluteURL":null
                  },
                  {
                     "values":[
                        {
                           "valueType":"StringSingle",
                           "elements":null,
                           "internalName":"3_Etapa_FamSeg",
                           "value":"Revisión del Autorizador"
                        },
                        {
                           "valueType":"StringSingle",
                           "elements":null,
                           "internalName":"3_Asignado_FamSeg",
                           "value":"Katherine Córdoba"
                        },
                        {
                           "valueType":"Date",
                           "elements":null,
                           "internalName":"3_Fecha_FamSeg",
                           "value":"2024-11-27T00:00:00"
                        },
                        {
                           "valueType":"Date",
                           "elements":null,
                           "internalName":"3_Completado_FamSeg",
                           "value":"2024-11-27T00:00:00"
                        },
                        {
                           "valueType":"StringMultiline",
                           "elements":null,
                           "internalName":"3_Razon_Rechazo_Seguimiento",
                           "value":null
                        }
                     ],
                     "id":4398,
                     "relativeURL":null,
                     "absoluteURL":null
                  },
                  {
                     "values":[
                        {
                           "valueType":"StringSingle",
                           "elements":null,
                           "internalName":"3_Etapa_FamSeg",
                           "value":"Revisión del Encargado de la Contabilidad"
                        },
                        {
                           "valueType":"StringSingle",
                           "elements":null,
                           "internalName":"3_Asignado_FamSeg",
                           "value":"Katherine Córdoba"
                        },
                        {
                           "valueType":"Date",
                           "elements":null,
                           "internalName":"3_Fecha_FamSeg",
                           "value":"2024-11-27T00:00:00"
                        },
                        {
                           "valueType":"Date",
                           "elements":null,
                           "internalName":"3_Completado_FamSeg",
                           "value":"2024-11-27T00:00:00"
                        },
                        {
                           "valueType":"StringMultiline",
                           "elements":null,
                           "internalName":"3_Razon_Rechazo_Seguimiento",
                           "value":null
                        }
                     ],
                     "id":4399,
                     "relativeURL":null,
                     "absoluteURL":null
                  },
                  {
                     "values":[
                        {
                           "valueType":"StringSingle",
                           "elements":null,
                           "internalName":"3_Etapa_FamSeg",
                           "value":"Revisión del Encargado de la Contabilidad"
                        },
                        {
                           "valueType":"StringSingle",
                           "elements":null,
                           "internalName":"3_Asignado_FamSeg",
                           "value":"Katherine Córdoba"
                        },
                        {
                           "valueType":"Date",
                           "elements":null,
                           "internalName":"3_Fecha_FamSeg",
                           "value":"2024-11-27T00:00:00"
                        },
                        {
                           "valueType":"Date",
                           "elements":null,
                           "internalName":"3_Completado_FamSeg",
                           "value":"2024-11-28T00:00:00"
                        },
                        {
                           "valueType":"StringMultiline",
                           "elements":null,
                           "internalName":"3_Razon_Rechazo_Seguimiento",
                           "value":"just b"
                        }
                     ],
                     "id":4400,
                     "relativeURL":null,
                     "absoluteURL":null
                  },
                  {
                     "values":[
                        {
                           "valueType":"StringSingle",
                           "elements":null,
                           "internalName":"3_Etapa_FamSeg",
                           "value":"Devolución de Trámite"
                        },
                        {
                           "valueType":"StringSingle",
                           "elements":null,
                           "internalName":"3_Asignado_FamSeg",
                           "value":"Lucrecia Céspedes"
                        },
                        {
                           "valueType":"Date",
                           "elements":null,
                           "internalName":"3_Fecha_FamSeg",
                           "value":"2024-11-28T00:00:00"
                        },
                        {
                           "valueType":"Date",
                           "elements":null,
                           "internalName":"3_Completado_FamSeg",
                           "value":"0001-01-01T00:00:00"
                        },
                        {
                           "valueType":"StringMultiline",
                           "elements":null,
                           "internalName":"3_Razon_Rechazo_Seguimiento",
                           "value":null
                        }
                     ],
                     "id":4422,
                     "relativeURL":null,
                     "absoluteURL":null
                  }
               ],
               "internalName":"6_GC_Revisión",
               "value":null
            }
         ]
      }
        ]`;

        this.detailTask.value = JSON.parse(response);
    }

    async fetchCountTaskByProcessOffline():Promise<void>{
        const response = `[
      {
         "process":"Notificación Comex/DGA",
         "count":10
      },
      {
         "process":"Autorizaciones - Flujo 1",
         "count":2
      },
      {
         "process":"Flujo Movimiento interno",
         "count":3
      },
      {
         "process":"Asignación automática de lotes",
         "count":1
      },
      {
         "process":"Demo",
         "count":78
      },
      {
         "process":"Control de vencimiento de plazo",
         "count":3
      },
      {
         "process":"Solicitud de Contratación",
         "count":11
      },
      {
         "process":"Informe de Adjudicación",
         "count":2
      },
      {
         "process":"Orden de Pago",
         "count":20
      },
      {
         "process":"Módulo Devolutivo Derechos 2.0",
         "count":1
      },
      {
         "process":"Autorizaciones - Flujo 3",
         "count":7
      },
      {
         "process":"Autorizaciones - Flujo 2",
         "count":1
      }
        ]`
        this.countTaskByProcess.value = JSON.parse(response)
    }

    async fetchTasksOffline(userdata: string, status: string):Promise<void>{
      console.log(userdata);
      const responseStringVUI = `[
         {
             "taskId": 946781,
             "processId": 13839,
             "statusName": "Llegada",
             "processClassName": "Solicitud de Ingreso al Régimen de Zonas Francas",
             "processBaseReference": "VUI-2.1_1148",
             "processTheme1": "Primero",
             "processTheme2": "Administradora",
             "processTheme3": "Dentro del G.A.M",
             "processTheme4": "28/01/2023",
             "processTheme5": "",
             "processTheme6": "",
             "processTheme7": "",
             "processTheme8": "",
             "processTheme9": "",
             "processTheme10": "",
             "taskClassCode": "TP.64",
             "taskClassName": "Revisar requisitos que deben cumplir para la autorización ACFPA",
             "arrivalDate": "2024-11-01T11:03:26.373-06:00",
             "deadline": "2024-11-22T11:03:26.373-06:00",
             "noticeDate": "1900-01-01T00:00:00",
             "originalStartDatePrevision": "1900-01-01T00:00:00",
             "originalEndDatePrevision": "1900-01-01T00:00:00",
             "currentStartDatePrevision": "1900-01-01T00:00:00",
             "currentEndDatePrevision": "1900-01-01T00:00:00",
             "nameOfStartMessageCreator": "ApExt",
             "natureOfStartMessageCreator": "Externo",
             "isReclaimable": true,
             "project": "VUI"
           },
           {
             "taskId": 946788,
             "processId": 13757,
             "statusName": "Llegada",
             "processClassName": "Solicitud de Ingreso al Régimen de Zonas Francas",
             "processBaseReference": "VUI-2.1_1139",
             "processTheme1": "Segundo",
             "processTheme2": "Administradora",
             "processTheme3": "Dentro del G.A.M",
             "processTheme4": "10/08/2023",
             "processTheme5": "",
             "processTheme6": "",
             "processTheme7": "",
             "processTheme8": "",
             "processTheme9": "",
             "processTheme10": "",
             "taskClassCode": "TP.64",
             "taskClassName": "Revisar requisitos que deben cumplir para la autorización ACFPA",
             "arrivalDate": "2022-11-01T11:42:13.223-06:00",
             "deadline": "2024-11-22T11:42:13.223-06:00",
             "noticeDate": "1900-01-01T00:00:00",
             "originalStartDatePrevision": "1900-01-01T00:00:00",
             "originalEndDatePrevision": "1900-01-01T00:00:00",
             "currentStartDatePrevision": "1900-01-01T00:00:00",
             "currentEndDatePrevision": "1900-01-01T00:00:00",
             "nameOfStartMessageCreator": "WENDY TATIANA MORA PEREZ",
             "natureOfStartMessageCreator": "Externo",
             "isReclaimable": true,
             "project": "VUI"
           },
           {
             "taskId": 946850,
             "processId": 13839,
             "statusName": "Iniciada",
             "processClassName": "Solicitud de Ingreso al Régimen de Zonas Francas",
             "processBaseReference": "VUI-2.1_1148",
             "processTheme1": "Tercero",
             "processTheme2": "Administradora",
             "processTheme3": "Dentro del G.A.M",
             "processTheme4": "28/01/2023",
             "processTheme5": "",
             "processTheme6": "",
             "processTheme7": "",
             "processTheme8": "",
             "processTheme9": "",
             "processTheme10": "",
             "taskClassCode": "TP.110",
             "taskClassName": "Generar Acuerdo Ejecutivo de Revocatoria",
             "arrivalDate": "2022-11-03T18:09:57.227-06:00",
             "deadline": "2024-11-22T11:03:26.373-06:00",
             "noticeDate": "1900-01-01T00:00:00",
             "originalStartDatePrevision": "1900-01-01T00:00:00",
             "originalEndDatePrevision": "1900-01-01T00:00:00",
             "currentStartDatePrevision": "1900-01-01T00:00:00",
             "currentEndDatePrevision": "1900-01-01T00:00:00",
             "nameOfStartMessageCreator": "ApExt",
             "natureOfStartMessageCreator": "Externo",
             "isReclaimable": false,
             "project": "VUI"
           },
           {
             "taskId": 948922,
             "processId": 14457,
             "statusName": "Iniciada",
             "processClassName": "Solicitud de Ingreso al Régimen de Zonas Francas",
             "processBaseReference": "VUI-2.1_1177",
             "processTheme1": "Cuarto",
             "processTheme2": "Administradora.",
             "processTheme3": "Dentro del G.A.M",
             "processTheme4": "26/01/2023",
             "processTheme5": "",
             "processTheme6": "",
             "processTheme7": "",
             "processTheme8": "",
             "processTheme9": "",
             "processTheme10": "",
             "taskClassCode": "TP.26",
             "taskClassName": "Análisis del Acuerdo Ejecutivo abogado Leyes y Decretos",
             "arrivalDate": "2022-11-29T16:09:12.137-06:00",
             "deadline": "2024-11-22T11:03:26.373-06:00",
             "noticeDate": "1900-01-01T00:00:00",
             "originalStartDatePrevision": "1900-01-01T00:00:00",
             "originalEndDatePrevision": "1900-01-01T00:00:00",
             "currentStartDatePrevision": "1900-01-01T00:00:00",
             "currentEndDatePrevision": "1900-01-01T00:00:00",
             "nameOfStartMessageCreator": "ApExt",
             "natureOfStartMessageCreator": "Externo",
             "isReclaimable": false,
             "project": "VUI"
           },
           {
             "taskId": 952474,
             "processId": 14354,
             "statusName": "Iniciada",
             "processClassName": "Solicitud de Ingreso al Régimen de Zonas Francas",
             "processBaseReference": "VUI-2.1_1174",
             "processTheme1": "Quinto",
             "processTheme2": "Procesadora, Servicios y Comercializadora",
             "processTheme3": "Dentro del G.A.M",
             "processTheme4": "01/01/2023",
             "processTheme5": "",
             "processTheme6": "",
             "processTheme7": "",
             "processTheme8": "",
             "processTheme9": "",
             "processTheme10": "",
             "taskClassCode": "TP.118",
             "taskClassName": "Análisis y generación de Documentación ANALISTAS",
             "arrivalDate": "2023-02-28T15:52:39.947-06:00",
             "deadline": "2024-11-22T11:03:26.373-06:00",
             "noticeDate": "1900-01-01T00:00:00",
             "originalStartDatePrevision": "1900-01-01T00:00:00",
             "originalEndDatePrevision": "1900-01-01T00:00:00",
             "currentStartDatePrevision": "1900-01-01T00:00:00",
             "currentEndDatePrevision": "1900-01-01T00:00:00",
             "nameOfStartMessageCreator": "ApExt",
             "natureOfStartMessageCreator": "Externo",
             "isReclaimable": false,
             "project": "VUI"
           },
           {
             "taskId": 946781,
             "processId": 13839,
             "statusName": "Llegada",
             "processClassName": "Solicitud de Ingreso al Régimen de Zonas Francas",
             "processBaseReference": "VUI-2.1_1148",
             "processTheme1": "Sexto",
             "processTheme2": "Administradora",
             "processTheme3": "Dentro del G.A.M",
             "processTheme4": "28/01/2023",
             "processTheme5": "",
             "processTheme6": "",
             "processTheme7": "",
             "processTheme8": "",
             "processTheme9": "",
             "processTheme10": "",
             "taskClassCode": "TP.64",
             "taskClassName": "Revisar requisitos que deben cumplir para la autorización ACFPA",
             "arrivalDate": "2022-11-01T11:03:26.373-06:00",
             "deadline": "2024-11-22T11:03:26.373-06:00",
             "noticeDate": "1900-01-01T00:00:00",
             "originalStartDatePrevision": "1900-01-01T00:00:00",
             "originalEndDatePrevision": "1900-01-01T00:00:00",
             "currentStartDatePrevision": "1900-01-01T00:00:00",
             "currentEndDatePrevision": "1900-01-01T00:00:00",
             "nameOfStartMessageCreator": "ApExt",
             "natureOfStartMessageCreator": "Externo",
             "isReclaimable": true,
             "project": "VUI"
           },
           {
             "taskId": 946781,
             "processId": 13839,
             "statusName": "Llegada",
             "processClassName": "Solicitud de Ingreso al Régimen de Zonas Francas",
             "processBaseReference": "VUI-2.1_1148",
             "processTheme1": "Séptimo",
             "processTheme2": "Administradora",
             "processTheme3": "Dentro del G.A.M",
             "processTheme4": "28/01/2023",
             "processTheme5": "",
             "processTheme6": "",
             "processTheme7": "",
             "processTheme8": "",
             "processTheme9": "",
             "processTheme10": "",
             "taskClassCode": "TP.64",
             "taskClassName": "Revisar requisitos que deben cumplir para la autorización ACFPA",
             "arrivalDate": "2022-11-01T11:03:26.373-06:00",
             "deadline": "2024-11-22T11:03:26.373-06:00",
             "noticeDate": "1900-01-01T00:00:00",
             "originalStartDatePrevision": "1900-01-01T00:00:00",
             "originalEndDatePrevision": "1900-01-01T00:00:00",
             "currentStartDatePrevision": "1900-01-01T00:00:00",
             "currentEndDatePrevision": "1900-01-01T00:00:00",
             "nameOfStartMessageCreator": "ApExt",
             "natureOfStartMessageCreator": "Externo",
             "isReclaimable": true,
             "project": "VUI"
           },
           {
             "taskId": 946781,
             "processId": 13839,
             "statusName": "Llegada",
             "processClassName": "Solicitud de Ingreso al Régimen de Zonas Francas",
             "processBaseReference": "VUI-2.1_1148",
             "processTheme1": "Octavo",
             "processTheme2": "Administradora",
             "processTheme3": "Dentro del G.A.M",
             "processTheme4": "28/01/2023",
             "processTheme5": "",
             "processTheme6": "",
             "processTheme7": "",
             "processTheme8": "",
             "processTheme9": "",
             "processTheme10": "",
             "taskClassCode": "TP.64",
             "taskClassName": "Revisar requisitos que deben cumplir para la autorización ACFPA",
             "arrivalDate": "2022-11-01T11:03:26.373-06:00",
             "deadline": "2024-11-22T11:03:26.373-06:00",
             "noticeDate": "1900-01-01T00:00:00",
             "originalStartDatePrevision": "1900-01-01T00:00:00",
             "originalEndDatePrevision": "1900-01-01T00:00:00",
             "currentStartDatePrevision": "1900-01-01T00:00:00",
             "currentEndDatePrevision": "1900-01-01T00:00:00",
             "nameOfStartMessageCreator": "ApExt",
             "natureOfStartMessageCreator": "Externo",
             "isReclaimable": true,
             "project": "VUI"
           },
           {
             "taskId": 946781,
             "processId": 13839,
             "statusName": "Llegada",
             "processClassName": "Solicitud de Ingreso al Régimen de Zonas Francas",
             "processBaseReference": "VUI-2.1_1148",
             "processTheme1": "Noveno",
             "processTheme2": "Administradora",
             "processTheme3": "Dentro del G.A.M",
             "processTheme4": "28/01/2023",
             "processTheme5": "",
             "processTheme6": "",
             "processTheme7": "",
             "processTheme8": "",
             "processTheme9": "",
             "processTheme10": "",
             "taskClassCode": "TP.64",
             "taskClassName": "Revisar requisitos que deben cumplir para la autorización ACFPA",
             "arrivalDate": "2022-11-01T11:03:26.373-06:00",
             "deadline": "2024-11-22T11:03:26.373-06:00",
             "noticeDate": "1900-01-01T00:00:00",
             "originalStartDatePrevision": "1900-01-01T00:00:00",
             "originalEndDatePrevision": "1900-01-01T00:00:00",
             "currentStartDatePrevision": "1900-01-01T00:00:00",
             "currentEndDatePrevision": "1900-01-01T00:00:00",
             "nameOfStartMessageCreator": "ApExt",
             "natureOfStartMessageCreator": "Externo",
             "isReclaimable": true,
             "project": "VUI"
           },
           {
             "taskId": 946781,
             "processId": 13839,
             "statusName": "Llegada",
             "processClassName": "Solicitud de Ingreso al Régimen de Zonas Francas",
             "processBaseReference": "VUI-2.1_1148",
             "processTheme1": "Décimo",
             "processTheme2": "Administradora",
             "processTheme3": "Dentro del G.A.M",
             "processTheme4": "28/01/2023",
             "processTheme5": "",
             "processTheme6": "",
             "processTheme7": "",
             "processTheme8": "",
             "processTheme9": "",
             "processTheme10": "",
             "taskClassCode": "TP.64",
             "taskClassName": "Revisar requisitos que deben cumplir para la autorización ACFPA",
             "arrivalDate": "2022-11-01T11:03:26.373-06:00",
             "deadline": "2024-11-22T11:03:26.373-06:00",
             "noticeDate": "1900-01-01T00:00:00",
             "originalStartDatePrevision": "1900-01-01T00:00:00",
             "originalEndDatePrevision": "1900-01-01T00:00:00",
             "currentStartDatePrevision": "1900-01-01T00:00:00",
             "currentEndDatePrevision": "1900-01-01T00:00:00",
             "nameOfStartMessageCreator": "ApExt",
             "natureOfStartMessageCreator": "Externo",
             "isReclaimable": true,
             "project": "VUI"
           },
           {
             "taskId": 946781,
             "processId": 13839,
             "statusName": "Llegada",
             "processClassName": "Solicitud de Ingreso al Régimen de Zonas Francas",
             "processBaseReference": "VUI-2.1_1148",
             "processTheme1": "Onceavo",
             "processTheme2": "Administradora",
             "processTheme3": "Dentro del G.A.M",
             "processTheme4": "28/01/2023",
             "processTheme5": "",
             "processTheme6": "",
             "processTheme7": "",
             "processTheme8": "",
             "processTheme9": "",
             "processTheme10": "",
             "taskClassCode": "TP.64",
             "taskClassName": "Revisar requisitos que deben cumplir para la autorización ACFPA",
             "arrivalDate": "2022-11-01T11:03:26.373-06:00",
             "deadline": "2024-11-22T11:03:26.373-06:00",
             "noticeDate": "1900-01-01T00:00:00",
             "originalStartDatePrevision": "1900-01-01T00:00:00",
             "originalEndDatePrevision": "1900-01-01T00:00:00",
             "currentStartDatePrevision": "1900-01-01T00:00:00",
             "currentEndDatePrevision": "1900-01-01T00:00:00",
             "nameOfStartMessageCreator": "ApExt",
             "natureOfStartMessageCreator": "Externo",
             "isReclaimable": true,
             "project": "VUI"
           },
           {
             "taskId": 946781,
             "processId": 13839,
             "statusName": "Llegada",
             "processClassName": "Solicitud de Ingreso al Régimen de Zonas Francas",
             "processBaseReference": "VUI-2.1_1148",
             "processTheme1": "Doceavo",
             "processTheme2": "Administradora",
             "processTheme3": "Dentro del G.A.M",
             "processTheme4": "28/01/2023",
             "processTheme5": "",
             "processTheme6": "",
             "processTheme7": "",
             "processTheme8": "",
             "processTheme9": "",
             "processTheme10": "",
             "taskClassCode": "TP.64",
             "taskClassName": "Revisar requisitos que deben cumplir para la autorización ACFPA",
             "arrivalDate": "2022-11-01T11:03:26.373-06:00",
             "deadline": "2024-11-22T11:03:26.373-06:00",
             "noticeDate": "1900-01-01T00:00:00",
             "originalStartDatePrevision": "1900-01-01T00:00:00",
             "originalEndDatePrevision": "1900-01-01T00:00:00",
             "currentStartDatePrevision": "1900-01-01T00:00:00",
             "currentEndDatePrevision": "1900-01-01T00:00:00",
             "nameOfStartMessageCreator": "ApExt",
             "natureOfStartMessageCreator": "Externo",
             "isReclaimable": true,
             "project": "VUI"
           },
           {
             "taskId": 946781,
             "processId": 13839,
             "statusName": "Llegada",
             "processClassName": "Solicitud de Ingreso al Régimen de Zonas Francas",
             "processBaseReference": "VUI-2.1_1148",
             "processTheme1": "Treceavo",
             "processTheme2": "Administradora",
             "processTheme3": "Dentro del G.A.M",
             "processTheme4": "28/01/2023",
             "processTheme5": "",
             "processTheme6": "",
             "processTheme7": "",
             "processTheme8": "",
             "processTheme9": "",
             "processTheme10": "",
             "taskClassCode": "TP.64",
             "taskClassName": "Revisar requisitos que deben cumplir para la autorización ACFPA",
             "arrivalDate": "2022-11-01T11:03:26.373-06:00",
             "deadline": "2024-11-22T11:03:26.373-06:00",
             "noticeDate": "1900-01-01T00:00:00",
             "originalStartDatePrevision": "1900-01-01T00:00:00",
             "originalEndDatePrevision": "1900-01-01T00:00:00",
             "currentStartDatePrevision": "1900-01-01T00:00:00",
             "currentEndDatePrevision": "1900-01-01T00:00:00",
             "nameOfStartMessageCreator": "ApExt",
             "natureOfStartMessageCreator": "Externo",
             "isReclaimable": true,
             "project": "VUI"
           }
      ]`

     /*  const responseStringPROCOMER = `[
         {
             "taskId": 1573,
             "processId": 3330,
             "statusName": "Iniciada",
             "processClassName": "Solicitud de Contratación",
             "processBaseReference": "-55.1_33",
             "processTheme1": "Catorceavo",
             "processTheme2": "",
             "processTheme3": "",
             "processTheme4": "",
             "processTheme5": "",
             "processTheme6": "",
             "processTheme7": "",
             "processTheme8": "",
             "processTheme9": "",
             "processTheme10": "",
             "taskClassCode": "TP.6",
             "taskClassName": "Firma y aprobación solicitud de contratación",
             "arrivalDate": "2023-11-08T12:36:37.803-06:00",
             "deadline": "2024-11-22T11:03:26.373-06:00",
             "noticeDate": "1900-01-01T00:00:00",
             "originalStartDatePrevision": "1900-01-01T00:00:00",
             "originalEndDatePrevision": "1900-01-01T00:00:00",
             "currentStartDatePrevision": "1900-01-01T00:00:00",
             "currentEndDatePrevision": "1900-01-01T00:00:00",
             "nameOfStartMessageCreator": "AP1",
             "natureOfStartMessageCreator": "Empleado",
             "isReclaimable": false,
             "project": "SISTEMAS"
         },
         {
             "taskId": 1574,
             "processId": 3331,
             "statusName": "Iniciada",
             "processClassName": "Solicitud de Contratación",
             "processBaseReference": "-55.1_34",
             "processTheme1": "Quinceavo",
             "processTheme2": "",
             "processTheme3": "",
             "processTheme4": "",
             "processTheme5": "",
             "processTheme6": "",
             "processTheme7": "",
             "processTheme8": "",
             "processTheme9": "",
             "processTheme10": "",
             "taskClassCode": "TP.1",
             "taskClassName": "Gestionar la solicitud de contratación",
             "arrivalDate": "2023-11-08T16:45:49.1-06:00",
             "deadline": "1900-01-01T00:00:00",
             "noticeDate": "1900-01-01T00:00:00",
             "originalStartDatePrevision": "1900-01-01T00:00:00",
             "originalEndDatePrevision": "1900-01-01T00:00:00",
             "currentStartDatePrevision": "1900-01-01T00:00:00",
             "currentEndDatePrevision": "1900-01-01T00:00:00",
             "nameOfStartMessageCreator": "AP1",
             "natureOfStartMessageCreator": "Empleado",
             "isReclaimable": false,
             "project": "SISTEMAS"
         },
         {
             "taskId": 1575,
             "processId": 3348,
             "statusName": "Iniciada",
             "processClassName": "Solicitud de Contratación",
             "processBaseReference": "-55.1_35",
             "processTheme1": "Dieciseisavo",
             "processTheme2": "",
             "processTheme3": "",
             "processTheme4": "",
             "processTheme5": "",
             "processTheme6": "",
             "processTheme7": "",
             "processTheme8": "",
             "processTheme9": "",
             "processTheme10": "",
             "taskClassCode": "TP.1",
             "taskClassName": "Gestionar la solicitud de contratación",
             "arrivalDate": "2023-11-09T15:48:04.84-06:00",
             "deadline": "1900-01-01T00:00:00",
             "noticeDate": "1900-01-01T00:00:00",
             "originalStartDatePrevision": "1900-01-01T00:00:00",
             "originalEndDatePrevision": "1900-01-01T00:00:00",
             "currentStartDatePrevision": "1900-01-01T00:00:00",
             "currentEndDatePrevision": "1900-01-01T00:00:00",
             "nameOfStartMessageCreator": "AP1",
             "natureOfStartMessageCreator": "Empleado",
             "isReclaimable": false,
             "project": "SISTEMAS"
         },
         {
             "taskId": 1613,
             "processId": 3397,
             "statusName": "Iniciada",
             "processClassName": "Solicitud de Contratación",
             "processBaseReference": "TIN-55.1_42",
             "processTheme1": "Diecisiteavo",
             "processTheme2": "",
             "processTheme3": "",
             "processTheme4": "",
             "processTheme5": "",
             "processTheme6": "",
             "processTheme7": "",
             "processTheme8": "",
             "processTheme9": "",
             "processTheme10": "",
             "taskClassCode": "TP.1",
             "taskClassName": "Gestionar la solicitud de contratación",
             "arrivalDate": "2023-11-13T13:21:57.65-06:00",
             "deadline": "2023-11-16T13:21:57-06:00",
             "noticeDate": "1900-01-01T00:00:00",
             "originalStartDatePrevision": "1900-01-01T00:00:00",
             "originalEndDatePrevision": "1900-01-01T00:00:00",
             "currentStartDatePrevision": "1900-01-01T00:00:00",
             "currentEndDatePrevision": "1900-01-01T00:00:00",
             "nameOfStartMessageCreator": "AP1",
             "natureOfStartMessageCreator": "Empleado",
             "isReclaimable": false,
             "project": "SISTEMAS"
         },
         {
             "taskId": 1619,
             "processId": 3405,
             "statusName": "Llegada",
             "processClassName": "Solicitud de Contratación",
             "processBaseReference": "TIN-55.1_45",
             "processTheme1": "18",
             "processTheme2": "2023-11-14 13:27:08",
             "processTheme3": "Oficina en el Exterior",
             "processTheme4": "",
             "processTheme5": "",
             "processTheme6": "",
             "processTheme7": "",
             "processTheme8": "",
             "processTheme9": "",
             "processTheme10": "",
             "taskClassCode": "TP.1",
             "taskClassName": "Gestionar la solicitud de contratación",
             "arrivalDate": "2023-11-14T13:27:16.17-06:00",
             "deadline": "2023-11-15T13:27:16-06:00",
             "noticeDate": "1900-01-01T00:00:00",
             "originalStartDatePrevision": "1900-01-01T00:00:00",
             "originalEndDatePrevision": "1900-01-01T00:00:00",
             "currentStartDatePrevision": "1900-01-01T00:00:00",
             "currentEndDatePrevision": "1900-01-01T00:00:00",
             "nameOfStartMessageCreator": "AP1",
             "natureOfStartMessageCreator": "Empleado",
             "isReclaimable": false,
             "project": "SISTEMAS"
         },
         {
             "taskId": 1812,
             "processId": 3497,
             "statusName": "Llegada",
             "processClassName": "Informe de Adjudicación",
             "processBaseReference": "TIN-56.1_15",
             "processTheme1": "19",
             "processTheme2": "2023-11-29 10:30:18",
             "processTheme3": "",
             "processTheme4": "",
             "processTheme5": "",
             "processTheme6": "",
             "processTheme7": "",
             "processTheme8": "",
             "processTheme9": "",
             "processTheme10": "",
             "taskClassCode": "TP.1",
             "taskClassName": "Seguimiento de Tramites pendientes de tramitar",
             "arrivalDate": "2023-12-06T14:32:55.47-06:00",
             "deadline": "2024-11-22T11:03:26.373-06:00",
             "noticeDate": "1900-01-01T00:00:00",
             "originalStartDatePrevision": "1900-01-01T00:00:00",
             "originalEndDatePrevision": "1900-01-01T00:00:00",
             "currentStartDatePrevision": "1900-01-01T00:00:00",
             "currentEndDatePrevision": "1900-01-01T00:00:00",
             "nameOfStartMessageCreator": "AP1",
             "natureOfStartMessageCreator": "Empleado",
             "isReclaimable": false,
             "project": "SISTEMAS"
         }
      ]`*/

         this.tasks.value = await JSON.parse(responseStringVUI)
         //this.tasks.value = [...this.tasks.value, ...JSON.parse(responseStringPROCOMER)]
    }

    async fetchTasksOffline2():Promise<void>{
        /* const responseStringVUI = `[
            {
                "taskId": 946781,
                "processId": 13839,
                "statusName": "Llegada",
                "processClassName": "XXXXXX",
                "processBaseReference": "VUI-2.1_1148",
                "processTheme1": "FINCA ISLA DE LOS NEGRITOS SOCIEDAD ANONIMA",
                "processTheme2": "Administradora",
                "processTheme3": "Dentro del G.A.M",
                "processTheme4": "28/01/2023",
                "processTheme5": "",
                "processTheme6": "",
                "processTheme7": "",
                "processTheme8": "",
                "processTheme9": "",
                "processTheme10": "",
                "taskClassCode": "TP.64",
                "taskClassName": "Revisar requisitos que deben cumplir para la autorización ACFPA",
                "arrivalDate": "2022-11-01T11:03:26.373-06:00",
                "deadline": "2024-11-22T11:03:26.373-06:00",
                "noticeDate": "1900-01-01T00:00:00",
                "originalStartDatePrevision": "1900-01-01T00:00:00",
                "originalEndDatePrevision": "1900-01-01T00:00:00",
                "currentStartDatePrevision": "1900-01-01T00:00:00",
                "currentEndDatePrevision": "1900-01-01T00:00:00",
                "nameOfStartMessageCreator": "ApExt",
                "natureOfStartMessageCreator": "Externo",
                "isReclaimable": true,
                "project": "VUI"
              },
              {
                "taskId": 946788,
                "processId": 13757,
                "statusName": "Llegada",
                "processClassName": "Solicitud de Ingreso al Régimen de Zonas Francas",
                "processBaseReference": "VUI-2.1_1139",
                "processTheme1": "CIELO DIGITAL SOCIEDAD DE RESPONSABILIDAD LIMITADA",
                "processTheme2": "Administradora",
                "processTheme3": "Dentro del G.A.M",
                "processTheme4": "10/08/2023",
                "processTheme5": "",
                "processTheme6": "",
                "processTheme7": "",
                "processTheme8": "",
                "processTheme9": "",
                "processTheme10": "",
                "taskClassCode": "TP.64",
                "taskClassName": "Revisar requisitos que deben cumplir para la autorización ACFPA",
                "arrivalDate": "2022-11-01T11:42:13.223-06:00",
                "deadline": "2024-11-01T11:42:13.223-06:00",
                "noticeDate": "1900-01-01T00:00:00",
                "originalStartDatePrevision": "1900-01-01T00:00:00",
                "originalEndDatePrevision": "1900-01-01T00:00:00",
                "currentStartDatePrevision": "1900-01-01T00:00:00",
                "currentEndDatePrevision": "1900-01-01T00:00:00",
                "nameOfStartMessageCreator": "WENDY TATIANA MORA PEREZ",
                "natureOfStartMessageCreator": "Externo",
                "isReclaimable": true,
                "project": "VUI"
              },
              {
                "taskId": 946850,
                "processId": 13839,
                "statusName": "Iniciada",
                "processClassName": "Solicitud de Ingreso al Régimen de Zonas Francas",
                "processBaseReference": "VUI-2.1_1148",
                "processTheme1": "FINCA ISLA DE LOS NEGRITOS SOCIEDAD ANONIMA",
                "processTheme2": "Administradora",
                "processTheme3": "Dentro del G.A.M",
                "processTheme4": "28/01/2023",
                "processTheme5": "",
                "processTheme6": "",
                "processTheme7": "",
                "processTheme8": "",
                "processTheme9": "",
                "processTheme10": "",
                "taskClassCode": "TP.110",
                "taskClassName": "Generar Acuerdo Ejecutivo de Revocatoria",
                "arrivalDate": "2022-11-03T18:09:57.227-06:00",
                "deadline": "1900-01-01T00:00:00",
                "noticeDate": "1900-01-01T00:00:00",
                "originalStartDatePrevision": "1900-01-01T00:00:00",
                "originalEndDatePrevision": "1900-01-01T00:00:00",
                "currentStartDatePrevision": "1900-01-01T00:00:00",
                "currentEndDatePrevision": "1900-01-01T00:00:00",
                "nameOfStartMessageCreator": "ApExt",
                "natureOfStartMessageCreator": "Externo",
                "isReclaimable": false,
                "project": "VUI"
              },
              {
                "taskId": 948922,
                "processId": 14457,
                "statusName": "Iniciada",
                "processClassName": "Solicitud de Ingreso al Régimen de Zonas Francas",
                "processBaseReference": "VUI-2.1_1177",
                "processTheme1": "WALMART GSS LATIN AMERICA SOCIEDAD DE RESPONSABILIDAD LIMITADA",
                "processTheme2": "Administradora.",
                "processTheme3": "Dentro del G.A.M",
                "processTheme4": "26/01/2023",
                "processTheme5": "",
                "processTheme6": "",
                "processTheme7": "",
                "processTheme8": "",
                "processTheme9": "",
                "processTheme10": "",
                "taskClassCode": "TP.26",
                "taskClassName": "Análisis del Acuerdo Ejecutivo abogado Leyes y Decretos",
                "arrivalDate": "2022-11-29T16:09:12.137-06:00",
                "deadline": "1900-01-01T00:00:00",
                "noticeDate": "1900-01-01T00:00:00",
                "originalStartDatePrevision": "1900-01-01T00:00:00",
                "originalEndDatePrevision": "1900-01-01T00:00:00",
                "currentStartDatePrevision": "1900-01-01T00:00:00",
                "currentEndDatePrevision": "1900-01-01T00:00:00",
                "nameOfStartMessageCreator": "ApExt",
                "natureOfStartMessageCreator": "Externo",
                "isReclaimable": false,
                "project": "VUI"
              },
              {
                "taskId": 952474,
                "processId": 14354,
                "statusName": "Iniciada",
                "processClassName": "Solicitud de Ingreso al Régimen de Zonas Francas",
                "processBaseReference": "VUI-2.1_1174",
                "processTheme1": "FINCA ISLA DE LOS NEGRITOS SOCIEDAD ANONIMA",
                "processTheme2": "Procesadora, Servicios y Comercializadora",
                "processTheme3": "Dentro del G.A.M",
                "processTheme4": "01/01/2023",
                "processTheme5": "",
                "processTheme6": "",
                "processTheme7": "",
                "processTheme8": "",
                "processTheme9": "",
                "processTheme10": "",
                "taskClassCode": "TP.118",
                "taskClassName": "Análisis y generación de Documentación ANALISTAS",
                "arrivalDate": "2023-02-28T15:52:39.947-06:00",
                "deadline": "1900-01-01T00:00:00",
                "noticeDate": "1900-01-01T00:00:00",
                "originalStartDatePrevision": "1900-01-01T00:00:00",
                "originalEndDatePrevision": "1900-01-01T00:00:00",
                "currentStartDatePrevision": "1900-01-01T00:00:00",
                "currentEndDatePrevision": "1900-01-01T00:00:00",
                "nameOfStartMessageCreator": "ApExt",
                "natureOfStartMessageCreator": "Externo",
                "isReclaimable": false,
                "project": "VUI"
              }
         ]` 
         */

         const responseStringPROCOMER = `[
            {
                "taskId": 1573,
                "processId": 3330,
                "statusName": "Iniciada",
                "processClassName": "Solicitud de Contratación",
                "processBaseReference": "-55.1_33",
                "processTheme1": "",
                "processTheme2": "",
                "processTheme3": "",
                "processTheme4": "",
                "processTheme5": "",
                "processTheme6": "",
                "processTheme7": "",
                "processTheme8": "",
                "processTheme9": "",
                "processTheme10": "",
                "taskClassCode": "TP.6",
                "taskClassName": "Firma y aprobación solicitud de contratación",
                "arrivalDate": "2023-11-08T12:36:37.803-06:00",
                "deadline": "1900-01-01T00:00:00",
                "noticeDate": "1900-01-01T00:00:00",
                "originalStartDatePrevision": "1900-01-01T00:00:00",
                "originalEndDatePrevision": "1900-01-01T00:00:00",
                "currentStartDatePrevision": "1900-01-01T00:00:00",
                "currentEndDatePrevision": "1900-01-01T00:00:00",
                "nameOfStartMessageCreator": "AP1",
                "natureOfStartMessageCreator": "Empleado",
                "isReclaimable": false,
                "project": "SISTEMAS"
            },
            {
                "taskId": 1574,
                "processId": 3331,
                "statusName": "Iniciada",
                "processClassName": "Solicitud de Contratación",
                "processBaseReference": "-55.1_34",
                "processTheme1": "",
                "processTheme2": "",
                "processTheme3": "",
                "processTheme4": "",
                "processTheme5": "",
                "processTheme6": "",
                "processTheme7": "",
                "processTheme8": "",
                "processTheme9": "",
                "processTheme10": "",
                "taskClassCode": "TP.1",
                "taskClassName": "Gestionar la solicitud de contratación",
                "arrivalDate": "2023-11-08T16:45:49.1-06:00",
                "deadline": "1900-01-01T00:00:00",
                "noticeDate": "1900-01-01T00:00:00",
                "originalStartDatePrevision": "1900-01-01T00:00:00",
                "originalEndDatePrevision": "1900-01-01T00:00:00",
                "currentStartDatePrevision": "1900-01-01T00:00:00",
                "currentEndDatePrevision": "1900-01-01T00:00:00",
                "nameOfStartMessageCreator": "AP1",
                "natureOfStartMessageCreator": "Empleado",
                "isReclaimable": false,
                "project": "SISTEMAS"
            },
            {
                "taskId": 1575,
                "processId": 3348,
                "statusName": "Iniciada",
                "processClassName": "Solicitud de Contratación",
                "processBaseReference": "-55.1_35",
                "processTheme1": "",
                "processTheme2": "",
                "processTheme3": "",
                "processTheme4": "",
                "processTheme5": "",
                "processTheme6": "",
                "processTheme7": "",
                "processTheme8": "",
                "processTheme9": "",
                "processTheme10": "",
                "taskClassCode": "TP.1",
                "taskClassName": "Gestionar la solicitud de contratación",
                "arrivalDate": "2023-11-09T15:48:04.84-06:00",
                "deadline": "1900-01-01T00:00:00",
                "noticeDate": "1900-01-01T00:00:00",
                "originalStartDatePrevision": "1900-01-01T00:00:00",
                "originalEndDatePrevision": "1900-01-01T00:00:00",
                "currentStartDatePrevision": "1900-01-01T00:00:00",
                "currentEndDatePrevision": "1900-01-01T00:00:00",
                "nameOfStartMessageCreator": "AP1",
                "natureOfStartMessageCreator": "Empleado",
                "isReclaimable": false,
                "project": "SISTEMAS"
            },
            {
                "taskId": 1613,
                "processId": 3397,
                "statusName": "Iniciada",
                "processClassName": "Solicitud de Contratación",
                "processBaseReference": "TIN-55.1_42",
                "processTheme1": "",
                "processTheme2": "",
                "processTheme3": "",
                "processTheme4": "",
                "processTheme5": "",
                "processTheme6": "",
                "processTheme7": "",
                "processTheme8": "",
                "processTheme9": "",
                "processTheme10": "",
                "taskClassCode": "TP.1",
                "taskClassName": "Gestionar la solicitud de contratación",
                "arrivalDate": "2023-11-13T13:21:57.65-06:00",
                "deadline": "2023-11-16T13:21:57-06:00",
                "noticeDate": "1900-01-01T00:00:00",
                "originalStartDatePrevision": "1900-01-01T00:00:00",
                "originalEndDatePrevision": "1900-01-01T00:00:00",
                "currentStartDatePrevision": "1900-01-01T00:00:00",
                "currentEndDatePrevision": "1900-01-01T00:00:00",
                "nameOfStartMessageCreator": "AP1",
                "natureOfStartMessageCreator": "Empleado",
                "isReclaimable": false,
                "project": "SISTEMAS"
            },
            {
                "taskId": 1619,
                "processId": 3405,
                "statusName": "Llegada",
                "processClassName": "Solicitud de Contratación",
                "processBaseReference": "TIN-55.1_45",
                "processTheme1": "SANCHEZ QUIROS GABRIEL",
                "processTheme2": "2023-11-14 13:27:08",
                "processTheme3": "Oficina en el Exterior",
                "processTheme4": "",
                "processTheme5": "",
                "processTheme6": "",
                "processTheme7": "",
                "processTheme8": "",
                "processTheme9": "",
                "processTheme10": "",
                "taskClassCode": "TP.1",
                "taskClassName": "Gestionar la solicitud de contratación",
                "arrivalDate": "2023-11-14T13:27:16.17-06:00",
                "deadline": "2023-11-15T13:27:16-06:00",
                "noticeDate": "1900-01-01T00:00:00",
                "originalStartDatePrevision": "1900-01-01T00:00:00",
                "originalEndDatePrevision": "1900-01-01T00:00:00",
                "currentStartDatePrevision": "1900-01-01T00:00:00",
                "currentEndDatePrevision": "1900-01-01T00:00:00",
                "nameOfStartMessageCreator": "AP1",
                "natureOfStartMessageCreator": "Empleado",
                "isReclaimable": false,
                "project": "SISTEMAS"
            },
            {
                "taskId": 1812,
                "processId": 3497,
                "statusName": "Llegada",
                "processClassName": "Informe de Adjudicación",
                "processBaseReference": "TIN-56.1_15",
                "processTheme1": "",
                "processTheme2": "2023-11-29 10:30:18",
                "processTheme3": "",
                "processTheme4": "",
                "processTheme5": "",
                "processTheme6": "",
                "processTheme7": "",
                "processTheme8": "",
                "processTheme9": "",
                "processTheme10": "",
                "taskClassCode": "TP.1",
                "taskClassName": "Seguimiento de Tramites pendientes de tramitar",
                "arrivalDate": "2023-12-06T14:32:55.47-06:00",
                "deadline": "2025-12-08T14:32:55-06:00",
                "noticeDate": "1900-01-01T00:00:00",
                "originalStartDatePrevision": "1900-01-01T00:00:00",
                "originalEndDatePrevision": "1900-01-01T00:00:00",
                "currentStartDatePrevision": "1900-01-01T00:00:00",
                "currentEndDatePrevision": "1900-01-01T00:00:00",
                "nameOfStartMessageCreator": "AP1",
                "natureOfStartMessageCreator": "Empleado",
                "isReclaimable": false,
                "project": "SISTEMAS"
            },
            {
                "taskId": 1703,
                "processId": 3486,
                "statusName": "Llegada",
                "processClassName": " Módulo SICERE",
                "processBaseReference": "MS-58.1_56",
                "processTheme1": "JC INC LD",
                "processTheme2": "070124024306",
                "processTheme3": "Activación",
                "processTheme4": "",
                "processTheme5": "",
                "processTheme6": "",
                "processTheme7": "",
                "processTheme8": "",
                "processTheme9": "",
                "processTheme10": "",
                "taskClassCode": "TP.12",
                "taskClassName": "Firma solicitud",
                "arrivalDate": "2023-11-28T14:05:53.233-06:00",
                "deadline": "1900-01-01T00:00:00",
                "noticeDate": "1900-01-01T00:00:00",
                "originalStartDatePrevision": "1900-01-01T00:00:00",
                "originalEndDatePrevision": "1900-01-01T00:00:00",
                "currentStartDatePrevision": "1900-01-01T00:00:00",
                "currentEndDatePrevision": "1900-01-01T00:00:00",
                "nameOfStartMessageCreator": "ApExt",
                "natureOfStartMessageCreator": "Externo",
                "isReclaimable": false,
                "project": "SISTEMAS"
            }
         ]`

         //this.tasks.value = await JSON.parse(responseStringVUI)
         this.tasks.value = [...this.tasks.value, ...JSON.parse(responseStringPROCOMER)]
    }

    async setAmountOfTasks(userdata: string, status: string): Promise<void> {
        try {
            const URL = `${this.baseUrl}${config.endpoints.amountPersonalTasks}?userData=${encodeURIComponent(userdata)}&status=${encodeURIComponent(status)}`;

            const response = await fetch(URL, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            this.amountOfTasks.value = await response.json()
        } catch (error) {
            console.error('Error fetching tasks:', error);
            this.amountOfTasks.value = 0
            throw error;
        }   
    }

    async fetchCountOfTasksByProcess(userData: string, status: string): Promise<void> {
        try{
            const URL = `${this.baseUrl}${config.endpoints.countOfTasksByProcess}?userData=${encodeURIComponent(userData)}&status=${encodeURIComponent(status)}`;
            const response = await fetch(URL, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data: ApiResponse = await response.json();

            if (data.isSuccess && data.result) {
                this.countTaskByProcess.value = data.result as ICountTaskByProcess[]
            } else {
                console.error('Error en la respuesta:', data.errorMessages);
                throw new Error(data.errorMessages.join(', '));
            }
        } catch (error) {
            console.error('Error fetching count of tasks by process:', error);
            this.countTaskByProcess.value = [];
            throw error;
        } 
    }

    async fetchTaskNetApi(userdata: string, status: string): Promise<void> {
        this.loading.value = true;
        try {
            const URL = `${this.baseUrl}${config.endpoints.personalTaskSearch}?userData=${encodeURIComponent(userdata)}&status=${encodeURIComponent(status)}`;
            const response = await fetch(URL, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data: ApiResponse = await response.json();

            if (data.isSuccess && data.result) {
                this.tasks.value = data.result.map(task => ({
                    ...task,
                    Project: "SISTEMAS"
                })) as ITask[];
            } else {
                console.error('Error en la respuesta:', data.errorMessages);
                throw new Error(data.errorMessages.join(', '));
            }
        } catch (error) {
            console.error('Error fetching tasks:', error);
            this.tasks.value = [];
            throw error;
        } finally {
            this.loading.value = false;
        }
    }

    async fetchTaskDetail(userData: string, baseRef: string): Promise<void> {
      try {
         const URL = `${this.baseUrl}${config.endpoints.taskDetails}?userData=${encodeURIComponent(userData)}&baseRef=${encodeURIComponent(baseRef)}`;

         const response = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        const data: ApiResponse = await response.json();

        
         this.detailTask.value = data.result  as ITaskHistory[];
       

      } catch (error) {
         console.error('Error fetching tasks:', error);
         this.detailTask.value = [];
         throw error;
      }
    }
}
export default ApiService